import axios from '@/utils/axios';
import { Referral } from '../types';

const toRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' ? (value as Record<string, unknown>) : {};

const unwrapResponseData = (payload: unknown) => {
  const record = toRecord(payload);
  return record.data !== undefined ? record.data : payload;
};

const toCollection = (payload: unknown): Referral[] => {
  const responseData = unwrapResponseData(payload);

  if (Array.isArray(responseData)) return responseData as Referral[];

  const record = toRecord(responseData);
  const nested = ['referrals', 'items', 'results', 'data']
    .map((key) => record[key])
    .find((value) => Array.isArray(value));

  return Array.isArray(nested) ? (nested as Referral[]) : [];
};

const toItem = (payload: unknown): Referral => {
  const responseData = unwrapResponseData(payload);
  const record = toRecord(responseData);

  if (record.referral && typeof record.referral === 'object') {
    return record.referral as Referral;
  }

  return responseData as Referral;
};

export async function getReferrals(): Promise<Referral[]> {
  const { data } = await axios.get('/referrals');
  return toCollection(data);
}

export async function getReferral(id: number | string): Promise<Referral> {
  const { data } = await axios.get(`/referrals/${id}`);
  return toItem(data);
}
